<template>
  <div id="n_-0_TOP__">
    <div id="first_area">
      <div id="user_info">
        <div id="user_area">
          <div class="column_box">
            <div class="column">アプリ会員ID</div>
            <div class="column_text">
              {{ this.userId }}
            </div>
          </div>
          <div class="column_box">
            <div class="column">パスワード</div>
            <div class="column_text">
              {{ this.password }}
            </div>
          </div>
        </div>
        <div id="save" @click="goModelChange">
          <img src="@/assets/img/mypage/save_btn.png" alt="" />
        </div>
      </div>
    </div>

    <div id="renkei_area">
      <div class="item" v-if="canSIWA">
        <div class="item_text"><span>apple ID</span></div>
        <div
          class="item_image"
          v-if="this.isAppleLoggedIn === true"
          @click="goAppleLogin"
        >
          <img src="@/assets/img/mypage/renkei_on.png" alt="" />
        </div>
        <div class="item_image" v-else @click="goAppleLogin">
          <img src="@/assets/img/mypage/apple_off.png" alt="" />
        </div>
      </div>
    </div>
    <div id="rank_more" @click="tapRankMorePopup">
      <div class="image" v-if="this.userRank === '0'">
        <img src="@/assets/img/mypage/rank_more01.png" alt="" />
      </div>
      <div class="image" v-else-if="this.userRank === '1'">
        <img src="@/assets/img/mypage/rank_more02.png" alt="" />
      </div>
      <div class="image" v-else-if="this.userRank === '2'">
        <img src="@/assets/img/mypage/rank_more03.png" alt="" />
      </div>
      <div class="image" v-else-if="this.userRank === '3'">
        <img src="@/assets/img/mypage/rank_more04.png" alt="" />
      </div>
      <div class="image" v-else-if="this.userRank === '4'">
        <img src="@/assets/img/mypage/rank_more05.png" alt="" />
      </div>
      <div class="image" v-else-if="this.userRank === '5'">
        <img src="@/assets/img/mypage/rank_more06.png" alt="" />
      </div>
    </div>

    <div id="n_menu" v-if="canSIWA">
      <div class="menuItem">
        <div @click="goProfile">プロフィール設定</div>
        <div @click="goAppSetting">アプリ設定</div>
      </div>
      <div class="menuItem">
        <div @click="goSatmpHistory">スタンプ獲得履歴</div>
        <div @click="goModelChange">機種変更</div>
      </div>
      <div class="menuItem">
        <div @click="goAppleLogin">Apple IDと連携する</div>
        <div @click="goFaq">ヘルプ・<br />お問い合わせ</div>
      </div>
      <div class="menuItem">
        <div @click="goAcountDelete">アカウント削除</div>
        <div @click="goTermsOfUse">利用規約</div>
      </div>
      <div class="menuItem">
        <div @click="goPrivacyPolicy">個人情報保護方針</div>
        <div @click="goPrivacyPolicyForLocationInfo">
          位置情報に関する<br />
          個人情報保護方針
        </div>
      </div>
    </div>
    <div id="n_menu" v-else>
      <div class="menuItem">
        <div @click="goProfile">プロフィール設定</div>
        <div @click="goAppSetting">アプリ設定</div>
      </div>
      <div class="menuItem">
        <div @click="goSatmpHistory">スタンプ獲得履歴</div>
        <div @click="goModelChange">機種変更</div>
      </div>
      <div class="menuItem">
        <div @click="goFaq">ヘルプ・<br />お問い合わせ</div>
        <div @click="goAcountDelete">アカウント削除</div>
      </div>
      <div class="menuItem">
        <div @click="goTermsOfUse">利用規約</div>
        <div @click="goPrivacyPolicy">個人情報保護方針</div>
      </div>
      <div class="menuItem">
        <div @click="goPrivacyPolicyForLocationInfo">
          位置情報に関する<br />
          個人情報保護方針
        </div>
      </div>
    </div>
    <div id="version">{{ this.version }}</div>
    <template v-if="this.isUseAlert">
      <RankMorePopup
        :userType="this.userType"
        :userRank="this.userRank"
        :stampCardExpire="this.stampCardExpire"
        :version="this.version"
        @close="() => tapClose()"
      />
    </template>
    <VersionCheck
      :show="verAlert"
      :on-close="closeAlert"
      :msg="versionErrorMsg"
    />
  </div>
</template>
<script>
import { FactoryTrack } from '../constant/firebase.js'
import RankMorePopup from '@/components/Modal/RankMorePopup.vue'
import AlertAccountdelete from '../components/Modal/AlertAccountdelete'
import { mapActions } from 'vuex'
import DateFormatter from '../utils/DateFormatter.js'
import APIClient, { ErrorCode } from '@/api/APIClient'
import VersionCheck from './FAQWalkVersionCheck'
import '@/styles/color.css'
export default {
  name: 'MyPage',
  components: {
    RankMorePopup,
    VersionCheck
  },
  data: function () {
    return {
      isUseAlert: false,
      userId: '',
      password: '',
      userType: '0',
      userRank: '0',
      stampCardExpire: '',
      isLineLoggedIn: false,
      isAppleLoggedIn: false,
      canSIWA: false,
      version: '0',
      verAlert: 0,
      versionErrorMsg: ''
    }
  },
  created() {
    document.title = 'マイページ'
    const accTime = new DateFormatter().format(new Date())
    try {
      window.receivedToken = (payload) => {
        const json = JSON.parse(payload)
        this.userId = json.user_id
        this.userType = json.user_type
        this.userRank = json.user_rank
        this.version = json.version
        this.stampCardExpire = json.stamp_card_expire
        this.fetchUserLine(json)
        this.fetchUserSIWA(json)
        window.receivedToken = null
      }
      // クーポン一覧と同じなので一旦apiTypeを3に設定する
      this.actionRequestToken({ apiType: '3', acc_time: accTime })
    } catch (e) {
      console.log(e)
    }
    try {
      window.receivedPassword = (payload) => {
        this.password = payload
        window.receivedPassword = null
      }
      this.actionRequestPassword()
    } catch (e) {
      console.log(e)
    }
    try {
      window.receivedLineAccessToken = async (payload) => {
        const json = JSON.parse(payload)
        this.actionToggleLoading(true)
        const res = await APIClient.postLineLogin(
          json.app_token,
          json.acc_time,
          json.user_id,
          json.line_access_token
        )
        this.actionToggleLoading(false)
        let result = ''
        console.log(res)
        if (
          res.status === 200 &&
          res.data.data.code === ErrorCode.CODE_SUCCESS
        ) {
          this.isLineLoggedIn = true
        } else if (res.status === 200 && res.data.data.code === '4003000') {
          this.isLineLoggedIn = false
        } else {
          this.isLineLoggedIn = false
        }
      }
    } catch (e) {
      console.log(e)
    }
    try {
      window.receivedSIWAIdToken = async (payload) => {
        const json = JSON.parse(payload)
        this.actionToggleLoading(true)
        const res = await APIClient.postSIWA(
          json.app_token,
          json.acc_time,
          json.user_id,
          json.id_token,
          json.nonce
        )
        this.actionToggleLoading(false)
        let result = ''
        console.log(res)
        if (
          res.status === 200 &&
          res.data.data.code === ErrorCode.CODE_SUCCESS
        ) {
          this.isAppleLoggedIn = true
        } else if (res.status === 200 && res.data.data.code === '4003000') {
          this.isAppleLoggedIn = false
        } else {
          this.isAppleLoggedIn = false
        }
      }
    } catch (e) {
      console.log(e)
    }
    this.actionCanSIWA()
    try {
      window.receivedCanSIWA = (payload) => {
        console.log('receivedCanSIWA: ', payload)
        this.canSIWA = payload === 'true'
      }
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Modal', ['action_ToggleModal']),
    ...mapActions('Native', [
      'actionRequestToken',
      'actionRequestPassword',
      'actionOpenWalk',
      'actionNavigateTo',
      'actionOpenTermsOfUse',
      'actionOpenPrivacyPolicy',
      'actionOpenPrivacyPolicyForLocationInfo',
      'actionRequestSIWA',
      'actionCanSIWA',
      'actionLineLoginResult',
      'actionVer6_1',
      'actionRequestExternalLink'
    ]),
    async fetchUserLine(payload) {
      const token = payload.app_token
      const uId = payload.user_id
      const accTime = payload.acc_time
      const res = await APIClient.postFetchUserLine(token, accTime, uId)
      if (
        res.status === 200 &&
        res.data.data.code === ErrorCode.CODE_SUCCESS &&
        res.data.data.user_id.length > 0
      ) {
        this.isLineLoggedIn = true
      }
    },
    async fetchUserSIWA(payload) {
      const token = payload.app_token
      const userId = payload.user_id
      const accTime = payload.acc_time
      const res = await APIClient.postFetchUserSIWA(token, accTime, userId)
      if (
        res.status === 200 &&
        res.data.data.code === ErrorCode.CODE_SUCCESS &&
        res.data.data.user_id.length > 0
      ) {
        this.isAppleLoggedIn = true
      }
    },
    goLogbo: async function () {
      this.trackEvent(FactoryTrack.createLoginbonus())
      this.$router.push({ path: '/loginbonus' })
    },
    openWalk: async function () {
      this.trackEvent(FactoryTrack.createWalk())
      this.alert = await this.actionOpenWalk()
    },
    goFriend: async function () {
      this.trackEvent(FactoryTrack.createLoginbonus())
      this.$router.push({ path: '/faq/invitation' })
    },
    goProfile: async function () {
      this.trackEvent(FactoryTrack.createProfileUpdate())
      this.$router.push({ path: '/profile-setting' })
    },
    goAppSetting: async function () {
      this.trackEvent(FactoryTrack.createSettingApp())
      this.actionNavigateTo('1')
    },
    goSatmpHistory: async function () {
      this.trackEvent(FactoryTrack.createStampHistory())
      this.$router.push({ path: '/stamphistory' })
    },
    goPremium: async function () {
      this.trackEvent(FactoryTrack.createFAQPremium())
      this.$router.push({ path: '/faq/premium?showHeader=false' })
    },
    goModelChange: async function () {
      this.trackEvent(FactoryTrack.createFAQModelChange())
      this.$router.push({ path: '/faq/model-change' })
    },
    goLineLogin: async function () {
      this.trackEvent(FactoryTrack.createFAQLineLogin())
      this.$router.push('/line-login')
    },
    goAppleLogin: async function () {
      this.trackEvent(FactoryTrack.createFAQSIWA())
      this.$router.push('/siwa')
    },
    goFaq: async function () {
      this.trackEvent(FactoryTrack.createFAQTop())
      this.$router.push('/faq')
    },
    goAcountDelete: async function () {
      this.trackEvent(FactoryTrack.createFAQAcountDelete())
      this.$router.push('/faq/account-delete')
    },
    goTermsOfUse: async function () {
      this.trackEvent(FactoryTrack.createTermsOfService())
      this.alert = await this.actionOpenTermsOfUse()
    },
    goPrivacyPolicy: async function () {
      this.trackEvent(FactoryTrack.createPrivacyPolicy())
      this.alert = await this.actionOpenPrivacyPolicy()
    },
    goPrivacyPolicyForLocationInfo: async function () {
      this.trackEvent(FactoryTrack.createPrivacyPolicyForLocationInfo())
      this.alert = await this.actionOpenPrivacyPolicyForLocationInfo()
    },
    goSealCollection: async function () {
      this.trackEvent(FactoryTrack.createSealCollection())
      this.verAlert = await this.actionVer6_1()
      this.versionErrorMsg =
        'このボタンはアプリバージョン6.1.0以上対応です。<br />最新版のアプリにアップデートしてください。'
      if (this.verAlert === 0) {
        //this.$router.push('/seal')
        this.$router.push({
          name: 'Seal',
          params: { showItem: '開催中のキャンペーン' }
        })
      }
      return false
    },
    goGachaList: function () {
      this.trackEvent(FactoryTrack.createGachaList())
      this.$router.push('/gacha')
    },
    tapRankMorePopup() {
      this.action_ToggleModal(true)
      this.isUseAlert = true
    },
    tapClose() {
      this.action_ToggleModal(false)
      this.isUseAlert = false
    },
    closeAlert: function () {
      this.verAlert = 0
    }
  }
}
</script>
<style scoped lang="scss">
#n_-0_TOP__ {
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: var(--background-color);
}

#first_area {
  padding-top: 15px;
  width: 100%;
}

#version {
  width: 100%;
  margin-top: 25px;
  margin-bottom: 25px;
  text-align: center;
  font-weight: normal;
  font-size: 16px;
  color: rgba(153, 153, 153, 1);
}

#user_info {
  display: flex;
  width: 92%;
}
#user_area {
  width: 75%;
  position: relative;
  align-items: center;
}
#save {
  display: inline-block;
  width: 25%;
}
#save img {
  width: 100%;
  margin-top: 5px;
}
.column_box {
  display: flex;
  width: 75%;
  height: 13px;
  margin: 10px;
}
.column {
  width: 43%;
  margin-left: 5px;
  text-align: left;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  color: var(--dark-accent-color);
}
.column_text {
  width: 32%;
  margin-left: 10px;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: var(--dark-accent-color);
}
#renkei_area {
  width: 92%;
  margin: 5px;
  display: flex;
  position: relative;
}
#renkei_area .item {
  width: 50%;
  display: flex;
  align-items: center;
}
#renkei_area .item .item_text {
  width: 40%;
  padding-left: 10px;
  text-align: left;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  color: var(--dark-accent-color);
}
#renkei_area .item .item_image {
  text-align: right;
  width: 60%;
  display: flex;
  align-items: center;
}
#renkei_area .item .item_image img {
  width: 100%;
  margin: 0x;
  padding: 0x;
}
#rank_more {
  width: 100%;
  padding: 15px;
  text-align: center;
  margin-top: 10px;
}
#rank_more .image {
  width: 98%;
}
#rank_more .image img {
  width: 100%;
}
#stampget_text {
  padding: 15px;
}
#stampget_text img {
  width: 100%;
}

#seal_area, #gacha_area {
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 25px;
}
#seal_area img, #gacha_area img {
  width: 100%;
}

.menuItem {
  display: flex;
  padding: 0px;
}
.menuItem > div {
  display: flex;
  align-items: center;
  position: relative;
  width: 50%;
  background: #fff;
  border-left: 2px solid rgba(246, 246, 246, 1);
  border-bottom: 2px solid rgba(246, 246, 246, 1);
  height: 60px;
  padding-left: 15px;
  white-space: nowrap;
  line-height: 18px;
  text-align: left;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  color: rgba(51, 51, 51, 1);
}
.menuItem > div:after {
  content: '';
  display: inline-block;
  position: absolute;
  right: 15px;
  width: 7px;
  height: 12px;
  align-items: right;
  background-image: url(../assets/img/mypage/next_mark.png);
  background-size: contain;
}
#n_menu {
  width: 100%;
  height: 378px;
  left: 0px;
  margin-top: 20px;
}
</style>
